import "core-js/modules/es.string.trim.js";
/**
 * Determines whether two address are identical.
 * @param {Object} a
 * @param {Object} b
 * @returns bool
 */
export function isSameAddress(a, b) {
  var _a$country, _a$state, _b$country, _b$state;
  var comparableAddressA = {
    street: normalize(a.street),
    address_line_2: normalize(a.address_line_2),
    address_line_3: normalize(a.address_line_3),
    address_complement: normalize(a.address_complement),
    city: normalize(a.city),
    zip: normalize(a.zip),
    country: normalize((_a$country = a.country) === null || _a$country === void 0 ? void 0 : _a$country.printable_name),
    state: normalize((_a$state = a.state) === null || _a$state === void 0 ? void 0 : _a$state.state_label)
  };
  var comparableAddressB = {
    street: normalize(b.street),
    address_line_2: normalize(b.address_line_2),
    address_line_3: normalize(b.address_line_3),
    address_complement: normalize(b.address_complement),
    city: normalize(b.city),
    zip: normalize(b.zip),
    country: normalize((_b$country = b.country) === null || _b$country === void 0 ? void 0 : _b$country.printable_name),
    state: normalize((_b$state = b.state) === null || _b$state === void 0 ? void 0 : _b$state.state_label)
  };
  return Object.equal(comparableAddressA, comparableAddressB);
}
function normalize(string) {
  if (string) {
    return string.toLowerCase().trim();
  }
  return "";
}